import { render, staticRenderFns } from "./FirmProfile.vue?vue&type=template&id=5f4c5f8f&scoped=true&"
import script from "./FirmProfile.vue?vue&type=script&lang=js&"
export * from "./FirmProfile.vue?vue&type=script&lang=js&"
import style0 from "./FirmProfile.vue?vue&type=style&index=0&id=5f4c5f8f&prod&scoped=true&lang=css&"
import style1 from "./FirmProfile.vue?vue&type=style&index=1&id=5f4c5f8f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f4c5f8f",
  null
  
)

export default component.exports